import React, { Dispatch, SetStateAction, useCallback } from 'react'

const useNumberChangeEvent = (
  update: Dispatch<SetStateAction<number>>,
  setIsEdited?: Dispatch<SetStateAction<boolean>>
) => {
  return useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      let value = event.target.value
      // 空文字であれば0にする
      if (/(?:)/.test(value)) {
        update(0)
      }
      // 全角数字が存在していれば全て半角数字に変換する
      value = value.replace(/[０-９]/g, (s) => {
        return String.fromCharCode(s.charCodeAt(0) - 0xfee0)
      })
      // 数値であれば数値型に変換して更新する
      if (/^[0-9]+$/.test(value)) {
        update(Number(value))
      }
      setIsEdited && setIsEdited(true)
    },
    [update, setIsEdited]
  )
}

export default useNumberChangeEvent
